import instance from '../../../api/axios'
import { SearchResponse } from '../types/search'

export const searchItems = async (name: string): Promise<SearchResponse> => {
  const response = await instance.get<SearchResponse>('/search', {
    params: { name },
  })

  return response.data
}
